const industrialParkRoutes = {
    name: 'industrialParkLayout',
    path: '/industrialPark',
    component: () => import('@/layout/index.vue'),
    redirect: '/industrialParkIndex',
    children: [
        {
            path: '/industrialParkIndex',
            component: () => import('@/views/industrialPark/index.vue'),
            meta: {
                title: '产业园'
            }
        }
    ]
}

const industrialParkWhite = [
    {
		path: '/industrialPark'
	},
    {
		path: '/industrialParkIndex'
	}
]

export {
    industrialParkRoutes,
    industrialParkWhite
}